import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=af1a93a8"
import script from "./HistoryComponent.vue?vue&type=script&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports